export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_PHYSICIAN = 'ROLE_PHYSICIAN';
export const ROLE_SALES = 'ROLE_SALES';

export const ROLE_LABEL = {
  [ROLE_ADMIN]: 'Administrator',
  [ROLE_PHYSICIAN]: 'Physician',
  [ROLE_SALES]: 'Sales Rep',
};

export const ROLE_LIST = Object.keys(ROLE_LABEL)
  .map(value => ({ label: ROLE_LABEL[value], value }));



// WEBPACK FOOTER //
// ./src/constants/roles.js